import { ErrorTypes } from '@fabric-ui/components';
import { envVariables } from '@fabric-ui/utils';
import { isDebugMode, isSynthetics } from '@utils/AvRum';

declare const window: {
  pendo?: pendo.Pendo;
} & Window;

export const getPendo = () => window.pendo;

export const initializePendo = (pendoData: any) => {
  if (isDebugMode()) return;
  if (!window.pendo) {
    console.error(`${ErrorTypes.Pendo}: Pendo is not initialized. The script might have failed to load.`);
    return;
  }
  if (!pendoData) {
    console.error(`${ErrorTypes.Pendo}: Pendo initialization data is missing.`);
    return;
  }
  const { userId, email, role, roleId, roleName, accountId, accountName, accountType, accountCreated } = pendoData;
  try {
    window.pendo.initialize({
      visitor: {
        id: `${userId}_${envVariables.VITE_ENV}`,
        email: email?.replace(/^[^@]+/, '****') || '',
        role: role || '',
        roleId: roleId || '',
        roleName: roleName || '',
      },

      account: {
        id: `${accountId}_${envVariables.VITE_ENV}`,
        name: accountName || '',
        type: accountType || '',
        creationDate: accountCreated || '',
      },
    });
  } catch (error) {
    console.error(`${ErrorTypes.Pendo}: Error during Pendo initialization:`, error);
    console.error(`${ErrorTypes.Pendo}: Pendo initialization data:`, pendoData);
  }
};

export const initializePendoScript = () => {
  if (!isDebugMode() && !isSynthetics && envVariables.VITE_PENDO_API_KEY) {
    /* eslint-disable */
    (function (p, e, n, d) {
      let v;
      let w;
      let x;
      let y;
      let z;
      let o = (p[d] = p[d] || {});
      o._q = o._q || [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
      for (w = 0, x = v.length; w < x; ++w) {
        (function (method) {
          o[method] =
            o[method] ||
            function () {
              o._q[method === 'initialize' ? 'unshift' : 'push']([method].concat(Array.prototype.slice.call(arguments, 0)));
            };
        })(v[w]);
      }
      y = e.createElement(n);
      y.async = !0;
      y.src = `https://cdn.pendo.io/agent/static/${envVariables.VITE_PENDO_API_KEY}/pendo.js`;
      y.onerror = (...args) => {
        console.error(`${ErrorTypes.Pendo}: Pendo script failed to load.`, args);
      };
      y.onload = () => {
        if (p.pendo) {
          v.forEach(functionName => {
            const originalFn = p.pendo![functionName];
            if (typeof originalFn === 'function') {
              p.pendo![functionName] = function () {
                try {
                  return originalFn.apply(this, arguments);
                } catch (error) {
                  console.error(`${ErrorTypes.Pendo}: Error in pendo.${functionName}:`, error);
                  console.error(`${ErrorTypes.Pendo}: Arguments for pendo.${functionName}:`, Array.prototype.slice.call(arguments, 0));
                }
              };
            }
          });
        }
      };
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
    /* eslint-enable */
  }
};
